import { atom } from 'jotai';

export interface LoadingState {
  isLoading: boolean;
  message: string;
  progress?: number;
  type: 'spinner' | 'overlay' | 'inline';
}

// Base loading state atom
export const loadingStateAtom = atom<LoadingState>({
  isLoading: false,
  message: '',
  type: 'overlay',
});

// Derived atoms for easier state management
export const isLoadingAtom = atom(get => get(loadingStateAtom).isLoading);

export const loadingMessageAtom = atom(get => get(loadingStateAtom).message);

export const loadingTypeAtom = atom(get => get(loadingStateAtom).type);

export const loadingProgressAtom = atom(get => get(loadingStateAtom).progress);

// Action atoms
export const showLoadingAtom = atom(
  null,
  (
    get,
    set,
    message: string,
    type: 'spinner' | 'overlay' | 'inline' = 'overlay',
    progress?: number
  ) => {
    set(loadingStateAtom, {
      isLoading: true,
      message,
      type,
      progress,
    });
  }
);

export const updateProgressAtom = atom(
  null,
  (get, set, progress: number, message?: string) => {
    const currentState = get(loadingStateAtom);
    set(loadingStateAtom, {
      ...currentState,
      progress,
      message: message || currentState.message,
    });
  }
);

export const hideLoadingAtom = atom(null, (get, set) => {
  set(loadingStateAtom, {
    isLoading: false,
    message: '',
    type: 'overlay',
  });
});
